import importReact from "../../utils/importReact";

export default function initSearchModal() {
  const entrypoint = document.getElementById("search-modal-container");
  if (entrypoint) {
    import(/* webpackChunkName: "searchModal" */ "./SearchModal").then((e) => {
      const { searchPageLink, placeholder, searchFor } = entrypoint.dataset;
      importReact().then(([React, ReactDOM]) => {
        ReactDOM.render(
          React.createElement(e.default, {
            searchPageLink,
            placeholder,
            searchFor
          }),
          entrypoint
        );
      });
    });
  }
}
